import router from './router';
import socket from './socket';
import login from './login';
import core from './core';
import modal from './modal';
import user from './user';
import project from './project';
import projectManager from './project-manager';
import board from './board';
import boardMembership from './board-membership';
import label from './label';
import list from './list';
import card from './card';
import task from './task';
import attachment from './attachment';
import actions from './actions';
import action from './action';
import commentAction from './comment-action';
import notification from './notification';

export default [
  router,
  socket,
  login,
  core,
  modal,
  user,
  project,
  projectManager,
  board,
  boardMembership,
  label,
  list,
  card,
  task,
  attachment,
  actions,
  action,
  commentAction,
  notification,
];
